/**
 * @generated SignedSource<<ae3067cdac0257de33e474897d501724>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddAllStudyPanelRecruitsInput = {
  clientMutationId?: string | null;
  countToRecruit?: number | null;
  excludeIds?: ReadonlyArray<string | null> | null;
  panelFilters?: any | null;
  randomize?: boolean | null;
  recruitId?: string | null;
  searchTerm?: string | null;
};
export type RecruitMatch_addAllStudyPanelRecruits_Mutation$variables = {
  input: AddAllStudyPanelRecruitsInput;
};
export type RecruitMatch_addAllStudyPanelRecruits_Mutation$data = {
  readonly addAllStudyPanelRecruits: {
    readonly study: {
      readonly id: string;
    } | null;
  } | null;
};
export type RecruitMatch_addAllStudyPanelRecruits_Mutation = {
  response: RecruitMatch_addAllStudyPanelRecruits_Mutation$data;
  variables: RecruitMatch_addAllStudyPanelRecruits_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddAllStudyPanelRecruitsPayload",
    "kind": "LinkedField",
    "name": "addAllStudyPanelRecruits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudyNode",
        "kind": "LinkedField",
        "name": "study",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecruitMatch_addAllStudyPanelRecruits_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecruitMatch_addAllStudyPanelRecruits_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "25d993520455477f6f2da82e05cca30b",
    "id": null,
    "metadata": {},
    "name": "RecruitMatch_addAllStudyPanelRecruits_Mutation",
    "operationKind": "mutation",
    "text": "mutation RecruitMatch_addAllStudyPanelRecruits_Mutation(\n  $input: AddAllStudyPanelRecruitsInput!\n) {\n  addAllStudyPanelRecruits(input: $input) {\n    study {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a942cc4cdf105e1b7d3c873775d95a8e";

export default node;
